import { fragments } from '@/gql'
import gql from 'graphql-tag'
const q = gql`
    query SearcherResultProf(
      $searcherType: SearcherType,
      $itemType: String!, 
      $limit: Int, 
      $offset: Int, 
      $value: Value, 
      $filters: [Filter],
      $elIncludes: [ElInclude],
      $defaultConfidence: Float,
      $queryType: String,
      $hideAggs: Boolean,
      $hideMatches: Boolean,
      $noCache: Boolean
    ) {
      SearcherResultProf: SearcherResult (
        searcherType: $searcherType, 
        limit: $limit, 
        offset: $offset, 
        value: $value,
        filters: $filters,
        itemType: $itemType,
        elIncludes: $elIncludes,
        defaultConfidence: $defaultConfidence,
        queryType: $queryType,
        hideAggs: $hideAggs,
        hideMatches: $hideMatches,
        noCache: $noCache
      ) {
        ...profSearcherResult
      }
    }
    ${fragments.profMatchDetail}
    ${fragments.profSearcherResult}
    ${fragments.profSearchers}
    ${fragments.searchItems}
    ${fragments.profMatchReason}
    ${fragments.profession}
    ${fragments.companyDepartmentDetail}
    ${fragments.companyTypeTree}
    ${fragments.companyType}
  `
export default q
